// services/dashboardService.js
import api from './api';

export const obterDadosDashboardInstituicao = async () => {
  try {
    const response = await api.get(`/dashboard/instituicao`);
    // Assumimos que o backend agora inclui classes e cursos na resposta
    return response.data;
  } catch (error) {
    console.error('Erro ao obter dados do dashboard da instituição:', error);
    throw error;
  }
};

export const obterDadosDashboardAdmin = async () => {
  try {
    const response = await api.get('/dashboard/admin');
    return response.data;
  } catch (error) {
    console.error('Erro ao obter dados do dashboard admin:', error);
    throw error;
  }
};

export const obterDadosDashboardEstudante = async () => {
  try {
    const response = await api.get(`/dashboard/estudante`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter dados do dashboard do estudante:', error);
    throw error;
  }
};

// Remover a função que depende de tipoUsuario
// export const obterDadosDashboard = async (tipoUsuario) => {
//   try {
//     switch (tipoUsuario) {
//       case 'admin':
//         return await obterDadosDashboardAdmin();
//       case 'instituicao':
//         return await obterDadosDashboardInstituicao();
//       case 'estudante':
//         return await obterDadosDashboardEstudante();
//       default:
//         throw new Error('Tipo de usuário inválido');
//     }
//   } catch (error) {
//     console.error('Erro ao obter dados do dashboard:', error);
//     throw error;
//   }
// };

// Exportar individualmente, se necessário
export const getDashboardData = obterDadosDashboardInstituicao;
export const getAdminDashboardData = obterDadosDashboardAdmin; 
export const getEstudanteDashboardData = obterDadosDashboardEstudante;
